<template>
    <el-input-number @blur="blur" :class="[!isCenter && 'no-center','tag-m-input-number']" :style="{width:width}" @change="valueChange" :controls="controls" v-model="num" :min="min" :max="max" :step="1" :step-strictly="stepStrictly" :placeholder="placeholder"></el-input-number>
</template>
<script>
export default {
    name: 'inputNumber',
    props: {
        // 文本是否居中
        isCenter: {
            type: Boolean,
            default: true
        },
        // 是否使用控制按钮	
        controls: {
            type: Boolean,
            default: true
        },
        // 设置计数器允许的最小值
        min: {
            type: Number,
            default: 0
        },
        // 设置计数器允许的最大值
        max: {
            type: Number,
            default: Infinity
        },
        // 计数器步长
        step: {
            type: Number,
            default: 1
        },
        // 是否只能输入 step 的倍数
        stepStrictly: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: Number,
            default: undefined
        },
        // 控件的宽度
        width: {
            type: String,
            default: ''
        }
    },
    data() {
        return { 
            num: undefined
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.num = newVal
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        this.num = this.value
    },
    methods: {
        valueChange(e) {
            this.num = e
            this.$emit('update:value',e)
            this.$emit('change',e)
        },
        blur(e) {
            this.$emit('blur',e)
        }
    }
}
</script>
<style scoped lang="scss">
    .no-center{
        ::v-deep(.el-input__inner) {
            text-align: unset;
        }
    }
</style>